import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import { IoDocumentsOutline } from "react-icons/io5";
import { DiGoogleAnalytics } from "react-icons/di";
import { BsPeopleFill } from "react-icons/bs";
import { BsFillPersonPlusFill } from "react-icons/bs";
import { FaReceipt } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import { IoMdSettings } from "react-icons/io";
import { IoLogOutSharp } from "react-icons/io5";
import { FaUserClock } from "react-icons/fa6";
import { MdManageSearch } from "react-icons/md";
import Cookies from "js-cookie";
import logo from "../images/sumukhalogo.png";
import { useYearContext } from "../../admin/components/YearContext";
import { MdPayments } from "react-icons/md";


const Empsidebar = ({ openSidebarToggle, openSidebar }) => {
  const navigate = useNavigate();
  const { clearYearFromLocalStorage } = useYearContext();

  const handleLogout = () => {
    Cookies.remove("token");
    localStorage.removeItem("role");
    clearYearFromLocalStorage();

    navigate("/login");
  };
  return (
    <aside
      id="invoice-sidebar"
      className={openSidebarToggle ? "sidebar-responsive" : ""}
    >
      <div className="sidebar-title">
        <div className="sidebar-brand d-flex gap-2  align-items-center">
          <img src={logo} className="w-25 h-25" />
          <h5>Manvitha Tax</h5>
        </div>
        <span className="icon close_icon" onClick={openSidebar}>
          X
        </span>
      </div>

      <ul className="sidebar-list">
        <li className="sidebar-list-item">
          <NavLink
            to="/employee"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <RxDashboard size={18} className="me-3" />
            Dashboard
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/empLeads"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <BsFillPersonPlusFill size={18} className="me-3" />
            Leads
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/empClients"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <BsPeopleFill size={18} className="me-3" />
            Clients
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/empdocuments"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <IoDocumentsOutline size={18} className="me-3" />
            Documents
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/empinvoices"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <FaReceipt size={18} className="me-3" />
            Invoices
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/emppayments"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <MdPayments size={18} className="me-3" />
            Payments
          </NavLink>
        </li>
        {/* <li className="sidebar-list-item">
          <NavLink
            to="/empshifts"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <FaUserClock size={18} className="me-3" />
            My Shifts
          </NavLink>
        </li> */}
         <li className="sidebar-list-item">
          <NavLink
            to="/empsearchclient"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <MdManageSearch size={20} className="me-3" />
            Search Client
          </NavLink>
        </li>
        <li className="sidebar-list-item">
          <NavLink
            to="/empProfile"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <CgProfile size={18} className="me-3" />
            My Profile
          </NavLink>
        </li>

        <li className="sidebar-list-item">
          <NavLink
            to="/empsettings"
            className={({ isActive }) => (isActive ? "active-link" : "")}
          >
            <IoMdSettings size={18} className="me-3" />
            Settings
          </NavLink>
        </li>

        <div className="sidebar-list-item" onClick={handleLogout}>
          <IoLogOutSharp size={18} className="me-3" />
          Logout
        </div>
      </ul>
    </aside>
  );
};

export default Empsidebar;
